// Weapon Charge — separate weapon progression resource (fills over time, gates S2/S3)
export const WEAPON_CHARGE = {
  PASSIVE_PER_TURN: 30,
  DAMAGE_DEALT_RATE: 2.0,
  DAMAGE_TAKEN_RATE: 1.0,
  BAR_HEIGHT: 4,
  BAR_X_INSET: 14,
  COLOR_EMPTY: 0x333355,
  COLOR_CHARGING: 0x4488ff,
  COLOR_HIGH: 0xaa66ff,
  COLOR_FULL: 0xffd700,
  PULSE_SPEED: 0.006,
  PULSE_MIN_ALPHA: 0.7,
  FILL_FLASH_DURATION: 0.15,
} as const;
